import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    detailChannel = new Subject();
    updateChannel = new Subject();
    updateDokumenChannel = new Subject();
    punishmentChannel = new Subject();
    repository = new UpdateRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.updateChannel.next({status: apiResponse.INITIAL})        
        this.updateDokumenChannel.next({status: apiResponse.INITIAL})        
        this.punishmentChannel.next({status: apiResponse.INITIAL})    
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchUpdate = async (query) => {
        try {
            this.updateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }
    fetchUpdatedokumen = async (query) => {
        try {
            this.updateDokumenChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdatedokumen(query).then((result) => {
                this.updateDokumenChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateDokumenChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchPunishment = async (query) => {
        try {
            this.punishmentChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPunishment(query).then((result) => {
                this.punishmentChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.punishmentChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }
}

export default UpdateBloc